var texts = {
  en: {
    emptyText: 'No data to display.',
  },
  sp: {
    emptyText: 'Sin datos para mostrar.',
  }
};

export default texts;